import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  ConfigureMultiTenantOrganizationHubNetworkActions,
  ConfigureMultiTenantOrganizationHubNetworkFulfilledAction,
} from '../../domains/multiTenantOrganizationConfigureHub/actions.types';
import type { MultiTenantOrganizationConfigureHubLifecycle } from '../types';

const initialState: MultiTenantOrganizationConfigureHubLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const stateWithFulfilled = (
  payload: ConfigureMultiTenantOrganizationHubNetworkFulfilledAction['payload']
): MultiTenantOrganizationConfigureHubLifecycle => {
  const { hubTenantId } = payload;

  const result = {
    hubTenantId,
  };

  return setFulfilled(result);
};

const reducer: Reducer<
  MultiTenantOrganizationConfigureHubLifecycle,
  ConfigureMultiTenantOrganizationHubNetworkActions
> = (state = initialState, action) => {
  switch (action.type) {
    case 'MULTI_TENANT_ORGANIZATION.CONFIGURE_HUB_PENDING':
      return setPending();
    case 'MULTI_TENANT_ORGANIZATION.CONFIGURE_HUB_FULFILLED':
      return stateWithFulfilled(action.payload);
    case 'MULTI_TENANT_ORGANIZATION.CONFIGURE_HUB_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
